type SoldPropertiesFilters = {
	display_name: string;
	filter_items: [];
	is_year: boolean;
	max_value: number;
	min_value: number;
	name: string;
	name_from: string;
	name_to: string;
	step: number;
	type: string;
	unit: string;
	value_from: number;
	value_to: number;
};

export type SoldPropertiesResponse = {
	numberOfHits: number;
	docs: SoldPropertiesPoiResult[];
	filters: SoldPropertiesFilters[];
	metadata: {
		vertical: string;
		search_key: string;
	};
};

export type SoldPropertiesPoiResult = {
	adId: number;
	lat: number;
	lon: number;
};

export type BBox = [west: number, south: number, east: number, north: number];

async function fetchSoldPropertiesData(
	proxyUrl: string | undefined,
	bbox?: BBox,
): Promise<SoldPropertiesResponse | undefined> {
	try {
		if (!proxyUrl) throw new Error("Proxy URL not found");
		const url = new URL(`${proxyUrl}/api/soldproperties`);

		if (bbox) {
			url.searchParams.set("bbox", bbox.map((v) => v.toFixed(5)).join(","));
		}

		const response = await fetch(url);
		if (!response.ok) throw new Error(`Server responded with status ${response.status}`);

		const soldPropertiesResponse = (await response.json()) as SoldPropertiesResponse;

		return soldPropertiesResponse;
	} catch (err) {
		console.error("Failed to fetch sold properties data", err);
		return undefined;
	}
}

export default fetchSoldPropertiesData;
